import type { ColumnDef } from '@tanstack/react-table';

import { GetDeliveryQuery } from 'data/__generated__';
import { textColumn, numberColumn } from 'components/DataTable';

import { StatusTag } from 'pages/StockTransfers/components/StatusTag';

export type DeliveryStockTransferRow = NonNullable<GetDeliveryQuery['delivery']>['stockTransfers'][number];

type DeliveryStockTransfersFilter = { searchValue?: string };

export const deliveryStockTransfersColumns: ColumnDef<DeliveryStockTransferRow, unknown>[] = [
    textColumn<DeliveryStockTransferRow, DeliveryStockTransfersFilter>({
        accessorKey: 'transferDate',
        header: 'Date de transfert',
        defaultVisible: true,
    }),
    {
        id: 'state',
        header: 'Statut',
        accessorFn: (row) => row.state,
        cell: ({ row }) => <StatusTag state={row.original.state} />,
        meta: { defaultVisible: true },
    },
    {
        id: 'originColumn',
        header: 'Colonne de départ',
        accessorFn: (row) => row.originColumn.fullname,
        cell: ({ row }) => <span>{row.original.originColumn.fullname}</span>,
        meta: { defaultVisible: true },
    },
    {
        id: 'destinationColumn',
        header: "Colonne d'arrivée",
        accessorFn: (row) => row.destinationColumn.fullname,
        cell: ({ row }) => <span>{row.original.destinationColumn.fullname}</span>,
        meta: { defaultVisible: true },
    },
    numberColumn<DeliveryStockTransferRow, DeliveryStockTransfersFilter>({
        accessorKey: 'numberOfRefs',
        header: 'Nb de références',
        defaultVisible: true,
    }),
    numberColumn<DeliveryStockTransferRow, DeliveryStockTransfersFilter>({
        accessorKey: 'quantityOfProducts',
        header: 'Nb de produits',
        defaultVisible: true,
    }),
    {
        id: 'reassortmentFlow',
        header: 'Flux de réassort',
        accessorFn: (row) => row.reassortmentFlow,
        cell: ({ row }) => <span>{row.original.reassortmentFlow ?? '—'}</span>,
        meta: { defaultVisible: true },
    },
];
